import React, { useState } from 'react'

import {
    AccordionItem,
    AccordionTitle,
    AccordionContent
} from './Accordion.style'

import { ReactComponent as ArrowDown } from 'assets/svg/accordion_arrow.svg'

const Accordion = ({
    title,
    color,
    showArrow = false,
    className,
    children
}) => {
    const [isOpen, setIsOpen] = useState(false)

    const toggleAccordion = () => {
        setIsOpen((open) => !open)
    }

    return (
        <AccordionItem className={className}>
            <AccordionTitle
                color={color}
                className={`Accordion__title${isOpen ? ' Accordion__title--open' : ''}`}
                onClick={toggleAccordion}
            >
                {title}
                {showArrow && <ArrowDown />}
            </AccordionTitle>
            <AccordionContent className="Accordion__desc" isOpen={isOpen}>
                {children}
            </AccordionContent>
        </AccordionItem>
    )
}

export default Accordion
